module.exports = __webpack_public_path__ + "4bb26941a7fc56acf1c1ac2afb35f58d.jpg";